/**
 * Blockiert die gesamte Anwendung, bis ein Benutzer mit
 * user.mustChangePassword=true ein neues Passwort vergeben hat (aktuell
 * ausschließlich der Systemadministrator beim ersten Login, siehe
 * database/migrations/0014_system_administrator.sql). Nutzt denselben
 * Endpunkt wie die reguläre Passwortänderung im Profil.
 */
import { useState, type FormEvent } from "react";
import { useAuth } from "../../context/AuthContext";
import { api, ApiError } from "../../api/client";
import { Logo } from "../ui/Logo";

export function ForcedPasswordChange() {
  const { refreshUser, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirmPassword) {
      setError("Die neuen Passwörter stimmen nicht überein.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/change-password", { currentPassword, newPassword });
      await refreshUser();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Fehler beim Ändern des Passworts.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-surface px-4 overflow-hidden">
      <div className="absolute inset-0 bg-carbon opacity-40" />
      <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 160px rgba(0,0,0,0.85)" }} />

      <div className="relative w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <Logo className="h-24 w-auto mb-2" />
          <p className="font-display text-sm text-sand uppercase tracking-[0.35em] mt-2">LBV-System</p>
        </div>

        <form onSubmit={handleSubmit} className="card p-6 space-y-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-100">Passwortänderung erforderlich</h2>
            <p className="text-sm text-gray-500 mt-1">
              Aus Sicherheitsgründen muss beim ersten Login des Systemadministrator-Kontos ein neues, persönliches Passwort vergeben werden, bevor das System genutzt werden kann.
            </p>
          </div>

          {error && <div className="bg-danger-muted text-danger text-sm rounded-lg px-3 py-2">{error}</div>}

          <div>
            <label className="label">Aktuelles Passwort</label>
            <input className="input" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </div>
          <div>
            <label className="label">Neues Passwort</label>
            <input className="input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} minLength={8} required />
          </div>
          <div>
            <label className="label">Neues Passwort bestätigen</label>
            <input className="input" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} minLength={8} required />
          </div>

          <button type="submit" disabled={submitting} className="btn-primary w-full py-2.5">
            {submitting ? "Wird geändert…" : "Passwort ändern und fortfahren"}
          </button>
          <button type="button" onClick={logout} className="btn-secondary w-full">
            Abmelden
          </button>
        </form>
      </div>
    </div>
  );
}
